import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useFlattenedFavourites = () => {
  const favourites = useSelector((state) => state.favourites);

  const memoizedFlattenedFavourites = useMemo(() => {
    return Object.keys(favourites).reduce(
      (previous, current, index) => [...previous, ...favourites[current]],
      []
    );
  }, [favourites]);

  return memoizedFlattenedFavourites;
};

export default useFlattenedFavourites;
